<template>
  <div
    class="culturalCustomMade"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="culturalCustomMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"
            >AI assisted cultural and creative customization</span
          >
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomMadeContent">
      <div class="section">
        <div class="content">
          <div
            class="item wow animate__fadeInDown animate__animated"
            @click="goItemDetail(item.id)"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="left">
              <img :src="item.imgSrc" alt="" />
            </div>
            <div class="right">
              <div class="title eng_title">{{ item.eng_title }}</div>
              <div class="introduce">{{ item.eng_introduce }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact_box">
      <el-popover placement="left" width="240" trigger="hover">
          <div class="tel">Contact Number：{{templeContact}}</div>
          <div class="tel">Email：regong_art_db@163.com</div>
          <div class="contact" slot="reference">
            <div class="made">
              <img src="../../assets/cultural/user.png" alt="" />
              <div class="hidden-xs-only">Manual customization services</div>
              <div class="hidden-sm-and-up">Customized services</div>
            </div>
          </div>
      </el-popover>
      <el-popover placement="left" width="240" trigger="hover">
          <div class="tel">Contact Number：{{templeContact}}</div>
          <div class="tel">Email：regong_art_db@163.com</div>
          <div class="contacts" slot="reference">
            <div class="mobile">
              <img src="../../assets/cultural/tel.png" alt="" />
              <div>Regong IP Authorization</div>
            </div>
          </div>
      </el-popover>
    </div>
    <div class="contact">
      <div class="made">
        <img src="../../assets/cultural/user.png" alt="" />
        <div class="hidden-xs-only">Manual customization services</div>
        <div class="hidden-sm-and-up">Customized services</div>
      </div>
      <div class="mobile">
        <img src="../../assets/cultural/tel.png" alt="" />
        <div>Regong IP Authorization</div>
      </div>
    </div>
  </div>
  <div class="culturalCustomMade" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="culturalCustomMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomMadeContent">
      <div class="section">
        <div class="content">
          <div
            class="item wow animate__fadeInDown animate__animated"
            @click="goItemDetail(item.id)"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="left">
              <img :src="item.imgSrc" alt="" />
            </div>
            <div class="right">
              <div class="title">{{ item.za_title }}</div>
              <div class="introduce za_introduce">{{ item.za_introduce }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact_box">
      <el-popover placement="left" width="240" trigger="hover">
          <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
          <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
          <div class="contact" slot="reference">
            <div class="made">
              <img src="../../assets/cultural/user.png" alt="" />
              <div class="hidden-xs-only">རྩོལ་བྱུང་གཏན་སྲོལ་ཞབས་ཞུ་</div>
              <div class="hidden-sm-and-up">མངག་བཟོ་ཞབས་ཞུ་</div>
            </div>
          </div>
      </el-popover>
      <el-popover placement="left" width="240" trigger="hover">
          <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
          <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
          <div class="contacts" slot="reference">
            <div class="mobile">
              <img src="../../assets/cultural/tel.png" alt="" />
              <div>རི་གོང་IPདབང་ཆ་བསྐུར་བ།</div>
            </div>
          </div>
      </el-popover>
    </div>
  </div>
  <div class="culturalCustomMade" v-else>
    <Pic-top></Pic-top>
    <div class="culturalCustomMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">AI辅助文创定制</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomMadeContent">
      <div class="section">
        <div class="content">
          <div
            class="item wow animate__fadeInDown animate__animated"
            @click="goItemDetail(item.id)"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="left">
              <img :src="item.imgSrc" alt="" />
            </div>
            <div class="right">
              <div class="title">{{ item.title }}</div>
              <div class="introduce">{{ item.introduce }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact_box">
      <el-popover placement="left" width="240" trigger="hover">
          <div class="tel">联系电话：{{templeContact}}</div>
          <div class="tel">邮件：regong_art_db@163.com</div>
          <div class="contact" slot="reference">
            <div class="made">
              <img src="../../assets/cultural/user.png" alt="" />
              <div class="hidden-xs-only">人工定制服务</div>
              <div class="hidden-sm-and-up">定制服务</div>
            </div>
          </div>
      </el-popover>
      <el-popover placement="left" width="240" trigger="hover">
          <div class="tel">联系电话：{{templeContact}}</div>
          <div class="tel">邮件：regong_art_db@163.com</div>
          <div class="contacts" slot="reference">
            <div class="mobile">
              <img src="../../assets/cultural/tel.png" alt="" />
              <div>热贡IP授权</div>
            </div>
          </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      list: [
        {
          id: 1,
          imgSrc: require("../../assets/cultural/0-1.png"),
          title: "热贡艺术元素检索",
          za_title: "བདུན།རེབ་གོང་སྒྱུ་རྩལ་གཞི་རྒྱུ་འཚོལ་ཞིབ།",
          za_introduce:
            "བརྒྱད།རྩི་ཐབས་ལ་བརྟེན་ནས་དམིགས་བསལ་རིགས་ཀྱི་ཐང་གའི་རི་མོའི་གཞི་རྒྱུ་བཙལ་འཚོལ་བྱས་ཏེ་བློ་འབྱེད་ཇུས་འགོད་ལ་སྤྱོད་ཀྱི་ཡོད། ཞིབ་འཇུག་དང་བཙལ་འཚོལ་བྱ་ཡུལ་གྱི་གཞི་རྒྱུ་ནི་རེབ་གོང་ས་ཁུལ་གྱི་ཐང་གའི་བརྩམས་ཆོས་ནས་ཐོན་པ་དང་། པར་དབང་ཐོག་མའི་གསར་རྩོམ་རྩོམ་པ་པོར་དབང་བས་ཚོང་ལས་ཐད་སྤྱོད་མི་རུང་། གལ་ཏེ་ཚོང་ལས་ཇུས་འགོད་ཐད་སྤྱོད་དགོས་ན། གཞི་གྲངས་མཛོད་དུ་ཞུགས་ནས་རེ་ཞུ་བྱེད་པའམ་ཡང་ནAIགྲུབ་པའི་གཞི་རྒྱུ་བཀོལ་དགོས།",
          eng_introduce:
            "Algorithms retrieve specific types of Thangka pattern elements to inspire design. It should be noted that the retrieved elements come from the Thangka works in the Regon area. The copyright belongs to the original author. Please do not use them for commercial purposes. For commercial design and use, please log in to the database to apply or use AI generation elements.",
          eng_title: "Regong Art Element Retrieval",
          introduce:
            "通过算法检索特定类型的唐卡图案元素，用于启发设计灵感。需注意所检索元素来自于热贡地区唐卡作品，版权归原创作者所有，请勿用于商业用途。如需商业设计使用，请登录数据库进行申请或使用AI生成元素。",
        },
        {
          id: 2,
          imgSrc: require("../../assets/cultural/0-2.png"),
          title: "热贡设计元素生成",
          za_title: "དགུ།རེབ་གོང་ཇུས་འགོད་གཞི་རྒྱུ་གྲུབ་པ།",
          za_introduce:
            "བཅུ།ཉམས་འགྱུར་གྱི་ནང་དོན་ལ་གཞིགས་ནས་བྲིས་པའིAIཐང་གའི་གཞི་རྒྱུ་ལས་གྲུབ་པའི་རྩི་ཐབས་སྤྱད་དེ་དམིགས་བསལ་རིགས་ཀྱི་ཐང་གའི་རི་མོའི་གཞི་རྒྱུ་གྲུབ་པ་རེད། མིག་སྔའི་ཚོད་ལྟའི་པར་གཞི་དེར་མེ་ཏོག་དང་། རི་ཆུ། སྤྲིན་བཅས་རིགས་བཞིར་ཕྱེ་ཡོད་པ་དང་། པར་གཞི་དེ་བས་མང་བ་ཞིག་ད་དུང་གཅིག་རྗེས་གཉིས་མཐུད་ངང་ཁ་སྣོན་བྱེད་བཞིན་ཡོད། AIགྲུབ་པའི་གཞི་རྒྱུ་དེ་རེབ་གོང་སྒྱུ་རྩལ་དྲིལ་བསྒྲགས་དང་ཇུས་འགོད་ཀྱི་བློ་འབྱེད་ཐད་ལ་སྤྱོད་ཀྱིན་ཡོད། གལ་ཏེ་སྤུས་ལེགས་ཅན་གྱི་ཐང་ག་དགོས་ཚེ་བརྩམས་ཆོས་འགྲེམས་ཚོང་དྲ་ངོས་ལ་འབྲེལ་བ་བྱས་ཏེ་ཆེད་བཟོ་བྱས་ཆོག",
          eng_introduce:
            "Through the AI Thangka element generation algorithm based on style content deconstruction, a specific category of Thangka pattern elements are generated. The current beta version has opened the generation of four categories: flower, mountain, water and cloud, and more versions are still being added. AI generation elements are only used for hot tribute art publicity and design inspiration. For exquisite Thangka works, please visit the exhibition page for customization.",
          eng_title: "Regon design element generation",
          introduce:
            "通过基于风格内容解构的AI唐卡元素生成算法，生成特定类别的唐卡图案元素。当前测试版开放了花、山、水、云四个类别的生成，更多版本还在陆续添加中。AI生成元素仅用于热贡艺术宣传及设计启发，如需精美的唐卡作品，请访问作品展销页定制。",
        },
        {
          id: 3,
          imgSrc: require("../../assets/cultural/0-3.png"),
          title: "热贡设计风格迁移",
          za_title: "བཅུ་གཅིག རེབ་གོང་ཇུས་འགོད་ཁྱད་ཆོས་ཀྱི་གནས་སྤོ།",
          za_introduce:
            "བཅུ་གཉིས། རེབ་གོང་གི་ཇུས་འགོད་གཞི་རྒྱུ་དེ་རེབ་གོང་སྒྱུ་རྩལ་ཉམས་འགྱུར་གྱི་གནས་སྤོའི་རྩི་ཐབས་བརྒྱུད་དུས་རྒྱུན་གྱི་པར་རིས་དེ་རེབ་གོང་གི་ཁྱད་ཆོས་སུ་བསྒྱུར་ཡོད། མིག་སྔར་དྲ་ཐོག་གནས་སྤོའི་ཚོད་ལྟའི་པར་གཞི་སྒོ་ཕྱེ་ཡོད་ལ། ཁྱེད་ཀྱིས་ཀྱང་དྲ་ཚིགས་འདིའི་ཐོག་ནས་རང་ཉིད་དགའ་སའི་རེབ་གོང་བརྩམས་ཆོས་བདམས་ཏེ་གནས་སྤོའི་རྣམ་པ་བྱས་ནས་ཚོད་སྤྱོད་བྱ་ཆོག  ཚོད་ལྟའི་པར་གཞི་ཞབས་ཞུ་ཆས་ཀྱི་རྩིས་ཤུགས་ལ་ཚད་ཡོད་པས། ཁྱེད་ཀྱི་སྙན་ཞུ་དེ་བཀོལ་སྤྱོད་ཀྱི་གནས་ཚུལ་ལ་གཞིགས་ནས་རིམ་པ་ལྟར་སྒུག་དགོས་།",
          eng_introduce:
            "Through the Regong art style migration algorithm, the daily image is migrated to the Regong color style. At present, the online migration beta version is open, and you can also choose your favorite Regong works from this website as the migration style for trial. Please note that the computing power of the beta server is limited, and your application may be queued according to usage.",
          eng_title: "Regong design style migration",
          introduce:
            "通过热贡艺术风格迁移算法，将日常图像迁移为热贡色彩风格。目前开放了在线迁移测试版，您也可以从本网站选择自己喜欢的热贡作品作为迁移风格进行试用。请注意测试版服务器算力受限，您的申请可能会依据使用情况进行排队等待。",
        },
      ],
      templeContact:'18997193666'
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  methods: {
    goItemDetail(id) {
      if (id == 1) {
        this.$router.push({
          path: "/culturalCustomSearchDetail",
          query: { id: id },
        });
      } else if (id == 2) {
        this.$router.push({
          path: "/culturalCustomSearchDetail",
          query: { id: id },
        });
      } else if (id == 3) {
        this.$router.push({ path: "/culturalCustomDetail" });
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss">
.culturalCustomMade {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .culturalCustomMadeTop {
    border-bottom: 1px solid #f4f5f6;
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .culturalCustomMadeContent {
    padding: 50px 0;
    position: relative;
    .section {
      .content {
        .item {
          align-items: center;
          display: flex;
          margin: 20px 0;
          .left {
            img {
              width: 320px;
            }
          }
          .right {
            display: flex;
            flex-direction: column;
            padding: 0 40px;
            cursor: pointer;
            .title {
              font-size: 28px;
              font-family: "fangzang";
              margin-bottom: 10px;
            }
            .eng_title {
              font-family: "Times New Roman", Times, serif;
            }
            .introduce {
              text-align: justify;
              line-height: 24px;
            }
            .za_introduce {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  .contact_box {
    z-index: 999;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 20%;
    .contact {
      margin-bottom: 20px;
      .made {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        width: 110px;
        height: 110px;
        border-radius: 100%;
        background-color: #99131a;
        box-shadow: 0 0 10px #99131a;
        margin-bottom: 20px;
        font-size: 12px;
        img {
          width: 32px;
          margin-bottom: 6px;
        }
      }
    }
    .contacts {
      .mobile {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        width: 110px;
        height: 110px;
        border-radius: 100%;
        background-color: #99131a;
        box-shadow: 0 0 10px #99131a;
        margin-bottom: 20px;
        font-size: 12px;
        img {
          width: 32px;
          margin-bottom: 6px;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .culturalCustomMade {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .culturalCustomMadeTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .culturalCustomMadeContent {
      padding: 0.1rem;
      .section {
        .content {
          .item {
            .left {
              img {
                width: 3rem;
              }
            }
            .right {
              padding: 0 0.1rem;
              .title {
                font-size: 0.4rem;
              }
              .introduce {
                overflow: hidden !important;
                overflow-wrap: break-word !important;
                text-overflow: ellipsis !important;
                display: -webkit-box !important;
                -webkit-line-clamp: 2 !important;
                -webkit-box-orient: vertical !important;
              }
            }
          }
        }
        .za_content {
          .item {
            .left {
              img {
                height: 100%;
              }
            }
            .right {
              .title {
                font-size: 0.32rem;
              }
            }
          }
        }
      }
    }
    .contact_box {
      right: 1%;
      // z-index: 1000;
      bottom: 35%;
      .contact {
        margin-bottom: 0;
        .made {
          width: 1.7rem;
          padding: 0.2rem;
          height: 1.7rem;
          margin-bottom: 0.2rem;
          img {
            width: 0.4rem;
          }
          div {
            font-size: 0.2rem;
          }
        }
      }
      .contacts {
        .mobile {
          width: 1.7rem;
          padding: 0.2rem;
          height: 1.7rem;
          margin-bottom: 0.2rem;
          img {
            width: 0.4rem;
          }
          div {
            font-size: 0.2rem;
          }
        }
      }
    }
  }
}
</style>
